/* global axios */
import ApiClient from './ApiClient';

class MabyApi extends ApiClient {
  constructor() {
    super('maby', { accountScoped: true });
  }

  ask(conversationId, question) {
    return axios.post(this.url, {
      conversation_id: conversationId,
      question,
    });
  }
}

export default new MabyApi();
